import { render, staticRenderFns } from "./DetailsInformationEve.vue?vue&type=template&id=48549c72&"
import script from "./DetailsInformationEve.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationEve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports